import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SATObjetoImpFilterSpec, Pageable, WrapperPageableResponse } from './service-common';

export interface SATObjetoImpDTO {
  id: string;
  name: string;
  description?: string;
  state?: 'ACTIVE' | 'INACTIVE';
}

export type WrapperPageableResponseSATObjetoImpDTO = WrapperPageableResponse<SATObjetoImpDTO>;

@Injectable({
  providedIn: 'root'
})
export class SATObjetoImpService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  list(
    spec: SATObjetoImpFilterSpec = {},
    pageable: Pageable = { page: 0, size: 200 }
  ): Observable<WrapperPageableResponseSATObjetoImpDTO> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => {
        params = params.append('sort', sort);
      });
    }

    return this.http.get<WrapperPageableResponseSATObjetoImpDTO>(
      `${this.apiUrl}/sat-objeto-imps`,
      { params }
    );
  }
}
